import { render } from "./TablaGestor.vue?vue&type=template&id=8a3574ee"
import script from "./TablaGestor.vue?vue&type=script&lang=js"
export * from "./TablaGestor.vue?vue&type=script&lang=js"

import "./TablaGestor.vue?vue&type=style&index=0&id=8a3574ee&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\2. Fabrica 2022\\Proyecto_Andres_Fabrica\\proyecto_llaves\\version_principal\\frontend_proyecto_llaves\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__